export default __webpack_public_path__ + "static/media/MBS .cc57380f.jpg";